import { render } from "./UserWorkflow.vue?vue&type=template&id=02df0206&scoped=true"
import script from "./UserWorkflow.vue?vue&type=script&lang=js"
export * from "./UserWorkflow.vue?vue&type=script&lang=js"

import "./UserWorkflow.vue?vue&type=style&index=0&id=02df0206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02df0206"]])

export default __exports__